function hr(props) {
  const { className } = props;
  return (
    <div className={`${className} w-full border-sentric-table-border border-b`} />
  );
}

export default hr;
